"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
(function () {
  // =============================================================================================
  // DEFIB SIM CONTROLLER. The facilitator's screen for a Defib Sim scenario (scenario.defibSim).
  // The learner works the ZOLL-style defibrillator on a tablet (defib/index.html); everything
  // they press arrives here through the same session as the rest of the simulator, and every
  // control on this screen goes through the same engine (useSimulation) as the main controller,
  // so shocks, pacing, drugs and rhythm changes behave identically in both.
  // =============================================================================================
  var _React = React,
    useState = _React.useState,
    useEffect = _React.useEffect;
  var fmt = function fmt(s) {
    var n = Math.max(0, Math.floor(Number(s) || 0));
    return "".concat(String(Math.floor(n / 60)).padStart(2, '0'), ":").concat(String(n % 60).padStart(2, '0'));
  };
  var TRIGGER_LABELS = {
    analyse: 'On analyse',
    shock: 'On shock',
    capture: 'On pacing capture',
    timer_30: 'After 30 s',
    timer_60: 'After 60 s',
    timer_120: 'After 2 min'
  };
  // The rhythms a defib scenario usually needs, first; the rest of the registry after them.
  var COMMON = ['VF', 'Fine VF', 'pVT', 'VT', 'PEA', 'Asystole', 'Sinus Rhythm', 'Sinus Tachycardia', 'Sinus Bradycardia', 'SVT', 'AF', 'Atrial Flutter', 'Complete Heart Block', '2nd Deg Heart Block', 'Junctional', 'Idioventricular'];

  // RCUK ALS drug timing (the same rules as the standalone Defib-sim): adrenaline as soon as
  // possible in a non-shockable rhythm, after the 3rd shock in a shockable one, then every 3-5
  // minutes; amiodarone after the 3rd shock and a further dose after the 5th. Sim seconds.
  function drugPrompts(state, adult, weight) {
    var a = state.arrest || {};
    if (a.since === null || a.since === undefined) return [];
    var RG = window.RHYTHMS;
    var shockable = RG.isShockable(state.rhythm);
    var adr = a.adrenaline || [],
      amio = a.amiodarone || [];
    var mg = function mg(perKg, cap, unit) {
      return weight ? " = ".concat(Math.min(cap, Math.round(perKg * weight)), " ").concat(unit) : '';
    };
    var adrDose = adult ? 'Adrenaline 1 mg IV' : "Adrenaline 10 micrograms/kg IV/IO".concat(mg(10, 1000, 'mcg'), " (max 1 mg)");
    var out = [];
    if (!adr.length) {
      if (!shockable) out.push("".concat(adrDose, " due now (non-shockable rhythm)"));else if (a.shocks >= 3) out.push("".concat(adrDose, " due (after the 3rd shock)"));
    } else if ((Number(state.time) || 0) - adr[adr.length - 1] >= 180) {
      out.push("".concat(adrDose, " due (3-5 min since the last dose)"));
    }
    if (shockable) {
      if (a.shocks >= 3 && amio.length === 0) out.push(adult ? 'Amiodarone 300 mg IV due (after the 3rd shock)' : "Amiodarone 5 mg/kg IV/IO".concat(mg(5, 300, 'mg'), " due (after the 3rd shock, max 300 mg)"));
      if (a.shocks >= 5 && amio.length === 1) out.push(adult ? 'Amiodarone 150 mg IV due (after the 5th shock)' : "Amiodarone 5 mg/kg IV/IO".concat(mg(5, 150, 'mg'), " due (after the 5th shock, max 150 mg)"));
      if (a.shocks >= 3 && adult) out.push('Refractory VF/pVT: consider changing the pad position (antero-posterior)');
      if (a.shocks >= 5 && !adult) out.push("Refractory VF/pVT (more than five shocks needed): increase the energy stepwise up to 8 J/kg".concat(weight ? " (".concat(Math.min(360, Math.round(8 * weight)), " J; this device's maximum is 200 J)") : ''));
    }
    return out;
  }
  var DefibSimScreen = function DefibSimScreen(_ref) {
    var sim = _ref.sim,
      onFinish = _ref.onFinish,
      onBack = _ref.onBack,
      sessionID = _ref.sessionID;
    var _window = window,
      Button = _window.Button,
      Lucide = _window.Lucide,
      Modal = _window.Modal,
      ECGMonitor = _window.ECGMonitor,
      INTERVENTIONS = _window.INTERVENTIONS;
    var RG = window.RHYTHMS;
    var state = sim.state,
      start = sim.start,
      pause = sim.pause,
      applyIntervention = sim.applyIntervention,
      addLogEntry = sim.addLogEntry,
      triggerArrest = sim.triggerArrest,
      triggerROSC = sim.triggerROSC,
      nextCycle = sim.nextCycle,
      changeRhythm = sim.changeRhythm;
    var nibp = state.nibp || {};
    var scenario = state.scenario || {};
    var ds = scenario.defibSim || {};
    var vitals = state.vitals || {};
    var defib = state.defib || {};
    var arrest = state.arrest || {
      since: null,
      shocks: 0,
      adrenaline: [],
      amiodarone: []
    };
    var steps = Array.isArray(ds.steps) ? ds.steps : [];
    var step = state.defibStep;
    var weight = Number(scenario.wetflag && scenario.wetflag.weight) || null;
    // Energies follow the device's adult threshold (40 kg or 18 years); drug doses follow the
    // RCUK paediatric chart for anyone under 18.
    var adult = RG.isAdult(weight, scenario.patientAge);
    var adultDrugs = adult && !(Number(scenario.patientAge) < 18);
    var education = ds.mode !== 'assessment';
    var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showJoin = _useState2[0],
      setShowJoin = _useState2[1];
    var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showScreens = _useState4[0],
      setShowScreens = _useState4[1];
    var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      showAllRhythms = _useState6[0],
      setShowAllRhythms = _useState6[1];
    var _useState7 = useState(''),
      _useState8 = _slicedToArray(_useState7, 2),
      note = _useState8[0],
      setNote = _useState8[1];

    // Space starts/pauses, as on the main controller (never while typing).
    useEffect(function () {
      var onKey = function onKey(e) {
        if (e.target && e.target.closest && e.target.closest('input, select, textarea, button')) return;
        if (e.key === ' ') {
          e.preventDefault();
          if (sim.state.isRunning) pause();else start();
        }
      };
      window.addEventListener('keydown', onKey);
      return function () {
        return window.removeEventListener('keydown', onKey);
      };
    });
    var confirmFinish = function confirmFinish() {
      if (window.confirm('End the Defib Sim and go to the debrief?')) onFinish();
    };

    // One rhythm change with the right obs: into arrest, out of arrest, or organised to organised.
    var setRhythm = function setRhythm(r) {
      var to = RG.canonical(r);
      if (to === RG.canonical(state.rhythm)) return;
      if (RG.isPulseless(to) && !RG.isPulseless(state.rhythm)) triggerArrest(to, 'facilitator');else if (!RG.isPulseless(to) && RG.isPulseless(state.rhythm)) triggerROSC(to, 'facilitator');else changeRhythm(to, 'facilitator');
    };

    // ---- Devices in the session
    var clients = state.remotePresence && state.remotePresence.clients || [];
    var defibClients = clients.filter(function (c) {
      return c.display === 'defib' || c.role === 'defib';
    });
    var mirrors = Object.values(state.deviceMirror || {});
    var mirror = mirrors.length ? mirrors.sort(function (a, b) {
      return (Number(b.ts) || 0) - (Number(a.ts) || 0);
    })[0] : null;
    var pacer = state.remotePacerState || {};
    var syncStatus = state.syncStatus || {
      state: 'connecting'
    };
    var syncProblem = ['unavailable', 'disconnected', 'error', 'degraded'].includes(syncStatus.state);
    var defibUrl = new URL("defib/index.html?session=".concat(sessionID), window.location.href).toString();

    // ---- Drugs
    var counts = state.interventionCounts || {};
    var active = state.activeInterventions || new Set();
    var lastGiven = function lastGiven(list) {
      return list.length ? "".concat(fmt((Number(state.time) || 0) - list[list.length - 1]), " ago") : null;
    };
    var drug = function drug(key, label, extra) {
      var def = INTERVENTIONS && INTERVENTIONS[key];
      if (!def) return null;
      var running = def.type === 'continuous' && active.has(key);
      var n = counts[key] || 0;
      return /*#__PURE__*/React.createElement("button", {
        key: key,
        type: "button",
        "data-drug": key,
        onClick: function onClick() {
          applyIntervention(key);
          if (extra) extra();
        },
        title: def.type === 'continuous' ? running ? 'Running: press again to stop' : 'Start the infusion' : def.label,
        className: "text-left px-2 py-1.5 rounded border text-xs font-bold ".concat(running ? 'bg-emerald-900/50 border-emerald-500 text-emerald-200' : 'bg-slate-800 border-slate-600 text-slate-200 hover:bg-slate-700')
      }, /*#__PURE__*/React.createElement("div", null, label || def.label, running ? ' — RUNNING' : ''), def.type !== 'continuous' && n > 0 && /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] font-normal text-slate-400"
      }, n, " given"));
    };
    var prompts = drugPrompts(state, adultDrugs, weight);

    // ---- Log (newest first)
    var log = (state.log || []).slice(-80).map(function (entry, i, arr) {
      return {
        entry: entry,
        index: state.log.length - arr.length + i
      };
    }).reverse();
    var logClass = function logClass(t) {
      return t === 'danger' ? 'text-red-300 font-bold' : t === 'warning' ? 'text-amber-300' : t === 'success' ? 'text-emerald-300 font-bold' : t === 'system' ? 'text-slate-400' : 'text-slate-300';
    };
    var card = 'bg-slate-800 border border-slate-700 rounded p-3';
    var h = 'text-[10px] uppercase tracking-widest font-bold text-slate-400 mb-2 flex items-center gap-1';
    var chip = function chip(on, onCls) {
      return "px-2 py-1.5 rounded border text-xs font-bold ".concat(on ? onCls : 'bg-slate-800 border-slate-600 text-slate-300 hover:bg-slate-700');
    };
    var pulseless = RG.isPulseless(state.rhythm);
    var noise = state.noise || {};
    var _window2 = window,
      Section = _window2.Section;

    // One-line summaries for the sections that start closed.
    var dset = state.defibSettings || {};
    var sr = dset.shockResponse || 'model';
    var shockSummary = [steps.length > 0 && step && !step.done ? 'custom sequence decides' : sr === 'model' ? 'Realistic model' : sr === 'auto' ? 'Auto' : sr === 'never' ? 'Never converts' : "Converts on shock ".concat(sr), dset.cvEnergy && dset.cvEnergy !== 'default' ? "cardioversion at ".concat(dset.cvEnergy, " J") : null, state.queuedRhythm ? "next shock \u2192 ".concat(RG.shortFor(state.queuedRhythm)) : null].filter(Boolean).join(" \xB7 ");
    var artefactsOn = [['movement', 'movement'], ['interference', 'mains'], ['tremor', 'tremor'], ['leadoff', 'lead off']].filter(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 1),
        k = _ref3[0];
      return noise[k];
    }).map(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        l = _ref5[1];
      return l;
    });
    var pacingSummary = "Threshold ".concat(state.pacingThreshold, " mA \xB7 ").concat(artefactsOn.length ? artefactsOn.join(', ') : 'no artefacts');
    var drugsSummary = "Adrenaline ".concat(arrest.adrenaline.length, " \xB7 Amiodarone ").concat(arrest.amiodarone.length);
    return /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 p-2 max-w-[1600px] mx-auto w-full",
      "data-testid": "defib-controller"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap justify-between items-center gap-2 bg-slate-800 p-2 rounded border border-slate-700"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 items-center"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "secondary",
      onClick: onBack,
      className: "h-8 px-2"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "arrow-left"
    }), " Back"), /*#__PURE__*/React.createElement(Button, {
      variant: "danger",
      onClick: confirmFinish,
      className: "h-8 px-2 font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "square"
    }), " Finish"), !state.isRunning ? /*#__PURE__*/React.createElement(Button, {
      variant: "success",
      onClick: start,
      className: "h-8 px-4 font-bold"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "play"
    }), " START") : /*#__PURE__*/React.createElement(Button, {
      variant: "warning",
      onClick: pause,
      className: "h-8 px-4"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "pause"
    }), " PAUSE"), /*#__PURE__*/React.createElement("div", {
      className: "min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] uppercase tracking-widest font-bold text-amber-400 flex items-center gap-1"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-3 h-3"
    }), " Defib Sim"), /*#__PURE__*/React.createElement("div", {
      className: "text-sm font-bold text-white truncate max-w-[22rem]"
    }, ds.name || scenario.title)), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] px-2 py-0.5 rounded border font-bold uppercase ".concat(education ? 'border-sky-600 text-sky-300 bg-sky-950/40' : 'border-violet-600 text-violet-300 bg-violet-950/40')
    }, education ? 'Education' : 'Assessment')), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap items-center gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      role: syncProblem ? 'alert' : 'status',
      title: syncStatus.message || '',
      className: "h-8 px-2 flex items-center gap-1 rounded border text-[10px] uppercase font-bold ".concat(syncProblem ? 'border-red-500 bg-red-950/60 text-red-300' : syncStatus.state === 'connected' ? 'border-emerald-700 bg-emerald-950/40 text-emerald-300' : 'border-amber-600 bg-amber-950/40 text-amber-300')
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: syncProblem ? 'wifi-off' : 'wifi',
      className: "w-3 h-3"
    }), " ", syncProblem ? 'Sync error' : syncStatus.state === 'connected' ? 'Session live' : 'Syncing'), /*#__PURE__*/React.createElement("div", {
      role: "status",
      "data-testid": "defib-presence",
      className: "h-8 px-2 flex items-center gap-1 rounded border text-[10px] uppercase font-bold ".concat(defibClients.length ? 'border-amber-500 bg-amber-950/40 text-amber-300' : 'border-slate-600 bg-slate-900 text-slate-400'),
      title: defibClients.length ? 'A defib tablet is linked to this session.' : 'No defib tablet is linked over the network yet (a defib in another tab of this browser links without appearing here).'
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "zap",
      className: "w-3 h-3"
    }), " ", defibClients.length ? defibClients.length === 1 ? 'Defib linked' : "".concat(defibClients.length, " defibs") : 'No defib tablet'), /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Screens: add patient screens and choose what each one shows",
      variant: "outline",
      onClick: function onClick() {
        return setShowScreens(true);
      },
      className: "h-8 px-2 text-sky-300 border-sky-500/50"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-4 h-4 mr-1"
    }), " Screens"), /*#__PURE__*/React.createElement(Button, {
      ariaLabel: "Show the QR code to open the defib",
      variant: "outline",
      onClick: function onClick() {
        return setShowJoin(true);
      },
      className: "h-8 px-2 text-sky-300 border-sky-500/50"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "qr-code",
      className: "w-4 h-4 mr-1"
    }), " Join"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        if (!window.SimScreens.openWindow('defib', sessionID)) window.open("defib/index.html?session=".concat(sessionID), '_blank');
      },
      className: "h-8 px-2 text-amber-400 border-amber-500/50"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "external-link",
      className: "w-4 h-4 mr-1"
    }), " Open defib"), /*#__PURE__*/React.createElement("div", {
      className: "font-mono text-2xl font-bold text-white ml-1"
    }, fmt(state.time)))), window.PatientStatus && /*#__PURE__*/React.createElement(window.PatientStatus.PatientStatusPanel, {
      sim: sim,
      addLogEntry: addLogEntry,
      showVent: false,
      setUp: true,
      extra: window.PatientScreenSwitch ? /*#__PURE__*/React.createElement(window.PatientScreenSwitch, {
        sim: sim,
        addLogEntry: addLogEntry,
        showVent: false,
        onOpenScreens: function onOpenScreens() {
          return setShowScreens(true);
        }
      }) : null
    }), !state.isRunning && !state.isFinished && /*#__PURE__*/React.createElement("div", {
      role: "status",
      "data-testid": "defib-clock-stopped",
      className: "flex items-center gap-2 px-3 py-2 rounded border border-amber-600 bg-amber-950/40 text-amber-200 text-xs"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "clock",
      className: "w-4 h-4 flex-none"
    }), state.pausedAt === null || state.pausedAt === undefined ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "The clock has not started."), " Log times stay at ", fmt(state.time), " until it does. Press START, or it starts by itself at the learner's first action on the defib.") : /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("b", null, "Paused."), " Presses are still logged, all at ", fmt(state.time), ", until you press START.")), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-1 lg:grid-cols-3 gap-2"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: card
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "user",
      className: "w-3 h-3"
    }), " Patient"), /*#__PURE__*/React.createElement("div", {
      className: "text-sm text-white font-bold"
    }, scenario.patientName, " (", window.shortAge(scenario.patientAge), " ", scenario.sex, weight ? ", ".concat(weight, " kg") : '', ")"), ds.description && /*#__PURE__*/React.createElement("p", {
      className: "text-xs text-slate-300 mt-1"
    }, ds.description), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1 mt-2 text-[10px]"
    }, ds.requiresSync && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-amber-600 text-amber-300"
    }, "Needs SYNC"), ds.requiresPacing && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-fuchsia-600 text-fuchsia-300"
    }, "Needs pacing"), ds.energyAdvice && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-slate-600 text-slate-300"
    }, "RCUK: ", ds.energyAdvice), ds.requiresPacing && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-slate-600 text-slate-300"
    }, "Capture threshold ", state.pacingThreshold, " mA"))), /*#__PURE__*/React.createElement("div", {
      className: "bg-black rounded border border-slate-700 overflow-hidden"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center px-2 pt-1"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-xs font-bold ".concat(pulseless ? 'text-red-300' : 'text-emerald-300'),
      "data-testid": "defib-rhythm"
    }, RG.labelFor(state.rhythm)), /*#__PURE__*/React.createElement("span", {
      className: "text-[10px] text-slate-400"
    }, "what the pads show")), /*#__PURE__*/React.createElement("div", {
      className: "h-40"
    }, /*#__PURE__*/React.createElement(ECGMonitor, {
      noise: state.noise,
      rhythmType: state.rhythm,
      hr: vitals.hr,
      rr: vitals.rr,
      spO2: vitals.spO2,
      etco2: vitals.etco2,
      isPaused: false,
      showTraces: true,
      showEcg: true,
      showPleth: !pulseless,
      showResp: false,
      showEtco2: false,
      showArt: false,
      isCPR: state.cprInProgress,
      showSyncMarkers: !!defib.syncMode,
      className: "h-full"
    })), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-4 gap-1 p-2 text-center font-mono"
    }, [['HR', function () {
      var q = RG.displayRate ? RG.displayRate(state.rhythm, vitals.hr) : vitals.hr;
      return q === null ? '---' : q;
    }(), 'text-emerald-400'], ['BP', "".concat(Math.round(vitals.bpSys || 0), "/").concat(Math.round(vitals.bpDia || 0)), 'text-red-300'], ['SpO₂', vitals.spO2, 'text-sky-300'], ['ETCO₂', Number(vitals.etco2 || 0).toFixed(1), 'text-yellow-300']].map(function (_ref6) {
      var _ref7 = _slicedToArray(_ref6, 3),
        l = _ref7[0],
        v = _ref7[1],
        c = _ref7[2];
      return /*#__PURE__*/React.createElement("div", {
        key: l
      }, /*#__PURE__*/React.createElement("div", {
        className: "text-[9px] text-slate-400"
      }, l), /*#__PURE__*/React.createElement("div", {
        className: "text-lg font-bold ".concat(c)
      }, typeof v === 'number' ? Math.round(v) : v));
    }))), /*#__PURE__*/React.createElement("div", {
      className: card,
      "data-testid": "device-mirror"
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "monitor",
      className: "w-3 h-3"
    }), " The learner's defib"), mirror ? /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-x-3 gap-y-1 text-xs"
    }, /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Mode"), /*#__PURE__*/React.createElement("span", {
      className: "text-white font-bold uppercase"
    }, mirror.mode), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Energy"), /*#__PURE__*/React.createElement("span", {
      className: "text-white font-bold"
    }, mirror.energy, " J ", mirror.sync ? /*#__PURE__*/React.createElement("span", {
      className: "text-amber-300"
    }, "SYNC") : null), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "State"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, mirror.machine), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Lead / size"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, mirror.lead, " x", mirror.gain), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Pacer"), /*#__PURE__*/React.createElement("span", {
      className: "text-white"
    }, mirror.pacerOutput, " mA, ", mirror.pacerRate, "/min, ", mirror.pacerDemand ? 'demand' : 'async'), /*#__PURE__*/React.createElement("span", {
      className: "text-slate-400"
    }, "Screen"), /*#__PURE__*/React.createElement("span", {
      className: "font-mono ".concat(mirror.messageType === 'alert' ? 'text-amber-300' : 'text-emerald-300')
    }, mirror.message || '—')) : /*#__PURE__*/React.createElement("div", {
      className: "text-xs text-slate-400 space-y-1"
    }, /*#__PURE__*/React.createElement("div", null, "From the learner's presses: mode ", /*#__PURE__*/React.createElement("b", {
      className: "text-white uppercase"
    }, defib.mode || 'off'), ", energy ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, defib.energy || '—', " J"), defib.syncMode ? /*#__PURE__*/React.createElement("b", {
      className: "text-amber-300"
    }, " SYNC") : null, ", pacer ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, Number(pacer.output) || 0, " mA / ", Number(pacer.rate) || 0, " per min"), "."), /*#__PURE__*/React.createElement("div", {
      className: "text-slate-400"
    }, "The full screen mirror appears when a tablet links with the session code.")), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-2 mt-2 text-[10px]"
    }, /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-slate-600 text-slate-300"
    }, "Shocks: ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, defib.shockCount || 0)), /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-slate-600 text-slate-300"
    }, "Last: ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, defib.lastEnergy ? "".concat(defib.lastEnergy, " J") : '—')), state.pacing && state.pacing.electrical && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-fuchsia-500 text-fuchsia-300 font-bold"
    }, state.pacing.mechanical ? 'Mechanical capture' : 'Electrical capture only'), defib.lastAnalysis && /*#__PURE__*/React.createElement("span", {
      className: "px-1.5 py-0.5 rounded border border-slate-600 text-slate-300"
    }, "Analysis: ", /*#__PURE__*/React.createElement("b", {
      className: "text-white"
    }, defib.lastAnalysis.result))))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 min-w-0"
    }, steps.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: card,
      "data-testid": "defib-steps-runner"
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "list",
      className: "w-3 h-3"
    }), " Custom sequence ", step && step.done ? '— complete' : ''), /*#__PURE__*/React.createElement("ol", {
      className: "space-y-1"
    }, steps.map(function (s, i) {
      var current = step && !step.done && step.index === i;
      var past = step && (step.done || step.index > i);
      return /*#__PURE__*/React.createElement("li", {
        key: i,
        className: "flex items-center justify-between gap-2 px-2 py-1 rounded border text-xs ".concat(current ? 'border-sky-500 bg-sky-950/40 text-white' : past ? 'border-slate-700 text-slate-400' : 'border-slate-700 text-slate-300')
      }, /*#__PURE__*/React.createElement("span", null, i + 1, ". ", RG.labelFor(s.rhythm)), /*#__PURE__*/React.createElement("span", {
        className: "text-[10px]"
      }, TRIGGER_LABELS[s.trigger] || s.trigger, current && /^timer_/.test(s.trigger) ? " (".concat(fmt((Number(state.time) || 0) - (Number(step.since) || 0)), ")") : ''));
    })), /*#__PURE__*/React.createElement("div", {
      className: "flex gap-2 mt-2"
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.goToDefibStep(step ? step.index + 1 : 1, 'facilitator');
      },
      disabled: !!(step && step.done),
      className: "h-8 text-xs flex-1"
    }, "Next step"), /*#__PURE__*/React.createElement(Button, {
      variant: "outline",
      onClick: function onClick() {
        return sim.goToDefibStep(0, 'facilitator restarted the sequence');
      },
      className: "h-8 text-xs flex-1"
    }, "Restart sequence"))), /*#__PURE__*/React.createElement("div", {
      className: card
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "activity",
      className: "w-3 h-3"
    }), " Rhythm"), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 sm:grid-cols-3 gap-1"
    }, (showAllRhythms ? RG.SELECTABLE : COMMON).map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        type: "button",
        "data-rhythm": r,
        onClick: function onClick() {
          return setRhythm(r);
        },
        className: chip(RG.canonical(state.rhythm) === r, RG.isPulseless(r) ? 'bg-red-800 border-red-400 text-white' : 'bg-emerald-800 border-emerald-400 text-white')
      }, RG.labelFor(r));
    })), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return setShowAllRhythms(!showAllRhythms);
      },
      className: "mt-2 text-[10px] text-sky-400 hover:text-sky-200 underline"
    }, showAllRhythms ? 'Fewer rhythms' : 'All rhythms')), window.InvResults && /*#__PURE__*/React.createElement(Section, {
      id: "defibInvResults",
      tone: "card",
      title: "Investigations: send or change",
      defaultOpen: false,
      summary: Object.keys(state.scenario.invChanged || {}).length ? "Changed: ".concat(Object.keys(state.scenario.invChanged).join(', ')) : "Scenario's own results"
    }, /*#__PURE__*/React.createElement(window.InvResults.LiveResults, {
      sim: sim,
      addLogEntry: addLogEntry
    })), /*#__PURE__*/React.createElement(Section, {
      id: "defibShock",
      tone: "card",
      title: "Shock response",
      summary: shockSummary,
      defaultOpen: false
    }, steps.length > 0 && step && !step.done ? /*#__PURE__*/React.createElement("p", {
      className: "text-[11px] text-sky-300 mb-2"
    }, "The custom sequence decides what a shock does until it completes.") : null, /*#__PURE__*/React.createElement("div", {
      className: "space-y-1"
    }, [['shockResponse', 'Converts', [['auto', 'Auto (scenario default)'], ['model', 'Realistic model (energy, CPR, drugs)'], ['1', '1st adequate shock'], ['2', '2nd adequate shock'], ['3', '3rd adequate shock'], ['4', '4th adequate shock'], ['5', '5th adequate shock'], ['never', 'Never (refractory)']]], ['rOnT', 'Unsync shock with a pulse', [['always', 'Always causes VF'], ['sometimes', 'Sometimes causes VF (1 in 3)'], ['never', 'No effect (flagged)']]], ['refib', 'After ROSC', [['off', 'Stays in ROSC'], ['once', 'VF recurs once (30-90 s)'], ['model', 'Realistic model']]], ['cvEnergy', 'Cardioversion succeeds at', [['default', 'Default (75 J adult, 1 J/kg child)']].concat(RG.ADULT_ENERGY_STEPS.map(function (j) {
      return [String(j), "".concat(j, " J or more")];
    }))]].map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 3),
        k = _ref9[0],
        label = _ref9[1],
        opts = _ref9[2];
      return /*#__PURE__*/React.createElement("label", {
        key: k,
        className: "flex items-center justify-between gap-2 text-[11px] text-slate-300"
      }, /*#__PURE__*/React.createElement("span", {
        className: "whitespace-nowrap"
      }, label), /*#__PURE__*/React.createElement("select", {
        value: (state.defibSettings || {})[k] || (k === 'cvEnergy' ? 'default' : ''),
        onChange: function onChange(e) {
          return sim.setDefibSettings(_defineProperty({}, k, e.target.value));
        },
        "aria-label": label,
        className: "min-w-0 max-w-[15rem] bg-slate-900 border border-slate-600 rounded px-1 py-0.5 text-[11px] text-white"
      }, opts.map(function (_ref0) {
        var _ref1 = _slicedToArray(_ref0, 2),
          v = _ref1[0],
          t = _ref1[1];
        return /*#__PURE__*/React.createElement("option", {
          key: v,
          value: v
        }, t);
      })));
    })), /*#__PURE__*/React.createElement("div", {
      className: "mt-2 text-[11px] text-slate-400"
    }, "Next shock converts to:", ' ', ['Sinus Rhythm', 'VF', 'PEA', 'Asystole'].map(function (r) {
      return /*#__PURE__*/React.createElement("button", {
        key: r,
        type: "button",
        onClick: function onClick() {
          return sim.setQueuedRhythm(r);
        },
        className: "ml-1 px-1.5 py-0.5 rounded border text-[10px] font-bold ".concat(state.queuedRhythm === r ? 'bg-sky-700 border-sky-400 text-white' : 'bg-slate-900 border-slate-600 text-slate-300')
      }, RG.shortFor(r));
    }), state.queuedRhythm && /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return sim.setQueuedRhythm(null);
      },
      className: "ml-2 text-sky-400 underline"
    }, "clear"))), /*#__PURE__*/React.createElement(Section, {
      id: "defibPacing",
      tone: "card",
      title: "Pacing & artefacts",
      summary: pacingSummary,
      defaultOpen: false
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between text-xs text-slate-300"
    }, /*#__PURE__*/React.createElement("span", null, "Capture threshold"), /*#__PURE__*/React.createElement("span", {
      className: "flex items-center gap-1"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "Lower the capture threshold",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_PACING_THRESHOLD',
          payload: (Number(state.pacingThreshold) || 70) - 5
        });
      },
      className: "w-6 h-6 rounded bg-slate-700 border border-slate-600"
    }, "-"), /*#__PURE__*/React.createElement("b", {
      className: "text-white w-14 text-center",
      "data-testid": "pacing-threshold"
    }, state.pacingThreshold, " mA"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "aria-label": "Raise the capture threshold",
      onClick: function onClick() {
        return sim.dispatch({
          type: 'SET_PACING_THRESHOLD',
          payload: (Number(state.pacingThreshold) || 70) + 5
        });
      },
      className: "w-6 h-6 rounded bg-slate-700 border border-slate-600"
    }, "+"))), /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mb-2"
    }, "Mechanical capture (a pulse) needs about 10 mA more."), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-wrap gap-1"
    }, [['movement', 'Patient movement'], ['interference', 'Mains interference'], ['tremor', 'Shivering / tremor'], ['leadoff', 'Lead off']].map(function (_ref10) {
      var _ref11 = _slicedToArray(_ref10, 2),
        k = _ref11[0],
        label = _ref11[1];
      return /*#__PURE__*/React.createElement("button", {
        key: k,
        type: "button",
        "data-artefact": k,
        "aria-pressed": !!noise[k],
        onClick: function onClick() {
          return sim.setNoise(_defineProperty({}, k, !noise[k]));
        },
        className: chip(!!noise[k], 'bg-amber-800 border-amber-400 text-white')
      }, label);
    })))), /*#__PURE__*/React.createElement("div", {
      className: "flex flex-col gap-2 min-w-0"
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(card, " ").concat(arrest.since !== null && arrest.since !== undefined ? 'border-red-600' : '')
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "heart-pulse",
      className: "w-3 h-3"
    }), " Arrest"), /*#__PURE__*/React.createElement("div", {
      className: "flex items-center justify-between text-xs mb-2"
    }, /*#__PURE__*/React.createElement("span", {
      className: arrest.since !== null && arrest.since !== undefined ? 'text-red-300 font-bold' : 'text-slate-400',
      "data-testid": "arrest-status"
    }, arrest.since !== null && arrest.since !== undefined ? "In arrest ".concat(fmt((Number(state.time) || 0) - arrest.since), " \u2014 ").concat(arrest.shocks, " shock").concat(arrest.shocks === 1 ? '' : 's') : 'Not in arrest'), /*#__PURE__*/React.createElement("span", {
      className: "font-mono text-lg text-white",
      title: "Time since the cycle timer was reset"
    }, fmt(state.cycleTimer))), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-1"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return sim.toggleCPR();
      },
      "aria-pressed": !!state.cprInProgress,
      className: chip(!!state.cprInProgress, 'bg-red-800 border-red-400 text-white')
    }, state.cprInProgress ? 'CPR running' : 'Start CPR'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return sim.setMetronome(!state.metronomeOn);
      },
      "aria-pressed": !!state.metronomeOn,
      className: chip(!!state.metronomeOn, 'bg-sky-800 border-sky-400 text-white')
    }, "Metronome ", state.metronomeOn ? 'ON' : 'off'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: nextCycle,
      className: chip(false),
      title: "Fast-forward 2 minutes to the next rhythm check"
    }, "Rhythm check (+2:00)"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      onClick: function onClick() {
        return triggerROSC('Sinus Rhythm', 'facilitator');
      },
      className: chip(false)
    }, "ROSC"), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-testid": "defib-capno",
      onClick: function onClick() {
        return applyIntervention('ToggleETCO2');
      },
      "aria-pressed": !!state.etco2Enabled,
      className: "col-span-2 ".concat(chip(!!state.etco2Enabled, 'bg-yellow-900 border-yellow-400 text-yellow-100')),
      title: "Attach or remove the CO2 sensor on the learner's defib"
    }, "Capnography ", state.etco2Enabled ? "ON (ETCO2 ".concat(Number(vitals.etco2 || 0).toFixed(1), " kPa)") : 'off'), /*#__PURE__*/React.createElement("button", {
      type: "button",
      "data-testid": "defib-nibp",
      disabled: !!nibp.inflating,
      onClick: function onClick() {
        sim.triggerNIBP();
        addLogEntry('NIBP cycled by facilitator', 'manual');
      },
      className: "col-span-2 ".concat(chip(!!nibp.inflating, 'bg-sky-900 border-sky-400 text-sky-100')),
      title: "Measure a blood pressure on the learner's defib now (the cuff takes about 5 seconds)"
    }, nibp.inflating ? 'NIBP measuring…' : "Cycle NIBP (defib shows ".concat(nibp.sys > 0 ? "".concat(Math.round(nibp.sys), "/").concat(Math.round(nibp.dia)) : '--/--', ")")))), prompts.length > 0 && /*#__PURE__*/React.createElement("div", {
      className: "p-2 rounded border border-amber-600 bg-amber-950/40 text-[11px] text-amber-200 space-y-0.5",
      "data-testid": "drug-prompts"
    }, /*#__PURE__*/React.createElement("div", {
      className: "font-bold uppercase text-[9px] tracking-widest text-amber-400"
    }, "RCUK prompts (facilitator only)"), prompts.map(function (p) {
      return /*#__PURE__*/React.createElement("div", {
        key: p
      }, "\u2022 ", p);
    })), /*#__PURE__*/React.createElement(Section, {
      id: "defibDrugs",
      tone: "card",
      title: "Drugs",
      summary: drugsSummary,
      defaultOpen: false
    }, /*#__PURE__*/React.createElement("div", {
      className: "text-[10px] text-slate-400 mb-1"
    }, "Adrenaline ", arrest.adrenaline.length ? "".concat(arrest.adrenaline.length, " this arrest, last ").concat(lastGiven(arrest.adrenaline)) : 'not given this arrest', " \xB7 Amiodarone ", arrest.amiodarone.length ? "".concat(arrest.amiodarone.length, " dose").concat(arrest.amiodarone.length > 1 ? 's' : '', ", last ").concat(lastGiven(arrest.amiodarone)) : 'not given'), /*#__PURE__*/React.createElement("div", {
      className: "grid grid-cols-2 gap-1"
    }, drug('AdrenalineIV', adultDrugs ? 'Adrenaline 1 mg IV' : 'Adrenaline 10 mcg/kg IV'), drug('Amiodarone', adultDrugs ? "Amiodarone ".concat(arrest.amiodarone.length ? '150' : '300', " mg IV") : 'Amiodarone 5 mg/kg IV', function () {
      if (adultDrugs && arrest.amiodarone.length) addLogEntry('Amiodarone: this is the second dose (150 mg).', 'info');
    }), drug('Atropine'), drug('Adenosine'), drug('Isoprenaline'), drug('AdrenalineInfusion'), drug('Fentanyl', 'Fentanyl (analgesia)'), drug('Midazolam', 'Midazolam (sedation)'))), /*#__PURE__*/React.createElement("div", {
      className: "".concat(card, " flex flex-col min-h-[14rem] max-h-[26rem]")
    }, /*#__PURE__*/React.createElement("div", {
      className: h
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "list",
      className: "w-3 h-3"
    }), " Event log"), /*#__PURE__*/React.createElement("form", {
      className: "flex gap-1 mb-2",
      onSubmit: function onSubmit(e) {
        e.preventDefault();
        if (note.trim()) {
          addLogEntry(note.trim(), 'manual', true);
          setNote('');
        }
      }
    }, /*#__PURE__*/React.createElement("input", {
      value: note,
      onChange: function onChange(e) {
        return setNote(e.target.value);
      },
      placeholder: "Add a note to the log",
      "aria-label": "Log note",
      className: "flex-1 min-w-0 bg-slate-900 border border-slate-600 rounded px-2 text-xs text-white h-7"
    }), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      variant: "outline",
      className: "h-7 px-2 text-xs"
    }, "Add")), /*#__PURE__*/React.createElement("div", {
      className: "flex-1 overflow-y-auto font-mono text-[11px] space-y-1",
      "data-testid": "defib-log"
    }, log.map(function (_ref12) {
      var entry = _ref12.entry,
        index = _ref12.index;
      return /*#__PURE__*/React.createElement("div", {
        key: index,
        className: "flex gap-2 ".concat(entry.flagged ? 'bg-amber-900/20' : '')
      }, /*#__PURE__*/React.createElement("button", {
        type: "button",
        "aria-label": "".concat(entry.flagged ? 'Unflag' : 'Flag', " log entry at ").concat(entry.simTime),
        onClick: function onClick() {
          return sim.dispatch({
            type: 'TOGGLE_FLAG',
            payload: index
          });
        },
        className: entry.flagged ? 'text-amber-500' : 'text-slate-400 hover:text-amber-500'
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "flag",
        className: "w-3 h-3"
      })), /*#__PURE__*/React.createElement("span", {
        className: "text-slate-400 flex-none",
        title: entry.time ? "Clock time ".concat(entry.time) : undefined
      }, entry.simTime), /*#__PURE__*/React.createElement("span", {
        className: logClass(entry.type)
      }, entry.msg));
    }))))), showScreens && window.ScreensPanel && /*#__PURE__*/React.createElement(Modal, {
      label: "Patient screens",
      onClose: function onClose() {
        return setShowScreens(false);
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "bg-slate-800 p-5 rounded-lg border border-slate-600 w-full max-w-3xl shadow-2xl max-h-[90vh] overflow-y-auto"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between items-center mb-3"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "text-lg font-bold text-white uppercase tracking-wider"
    }, "Patient screens"), /*#__PURE__*/React.createElement("button", {
      "aria-label": "Close screens",
      onClick: function onClick() {
        return setShowScreens(false);
      },
      className: "text-slate-400 hover:text-white"
    }, /*#__PURE__*/React.createElement(Lucide, {
      icon: "x",
      className: "w-5 h-5"
    }))), /*#__PURE__*/React.createElement(window.ScreensPanel, {
      sessionID: sessionID
    }), /*#__PURE__*/React.createElement(Button, {
      onClick: function onClick() {
        return setShowScreens(false);
      },
      variant: "outline",
      className: "w-full mt-4"
    }, "Done"))), showJoin && function () {
      var svg = null;
      try {
        var q = window.qrcode(0, 'M');
        q.addData(defibUrl);
        q.make();
        svg = q.createSvgTag({
          cellSize: 5,
          margin: 2,
          scalable: true
        }).replace('<svg ', '<svg style="width:100%;height:100%;display:block" ');
      } catch (e) {
        svg = null;
      }
      return /*#__PURE__*/React.createElement(Modal, {
        label: "Open the defib",
        onClose: function onClose() {
          return setShowJoin(false);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "bg-slate-800 p-6 rounded-lg border border-slate-600 w-full max-w-md shadow-2xl"
      }, /*#__PURE__*/React.createElement("div", {
        className: "flex justify-between items-center mb-2"
      }, /*#__PURE__*/React.createElement("h3", {
        className: "text-lg font-bold text-white uppercase tracking-wider"
      }, "Open the defib"), /*#__PURE__*/React.createElement("button", {
        "aria-label": "Close",
        onClick: function onClick() {
          return setShowJoin(false);
        },
        className: "text-slate-400 hover:text-white"
      }, /*#__PURE__*/React.createElement(Lucide, {
        icon: "x",
        className: "w-5 h-5"
      }))), /*#__PURE__*/React.createElement("p", {
        className: "text-xs text-slate-400 mb-3"
      }, "Point the tablet's camera at the code, or open ", /*#__PURE__*/React.createElement("span", {
        className: "font-mono"
      }, "defib/"), " and type the session code ", /*#__PURE__*/React.createElement("b", {
        className: "font-mono text-white text-base tracking-widest"
      }, sessionID), "."), svg ? /*#__PURE__*/React.createElement("div", {
        className: "bg-white p-2 rounded w-56 h-56 mx-auto",
        dangerouslySetInnerHTML: {
          __html: svg
        }
      }) : /*#__PURE__*/React.createElement("div", {
        className: "text-xs text-slate-400 text-center"
      }, "QR code unavailable \u2014 use the link below."), /*#__PURE__*/React.createElement("div", {
        className: "text-[10px] text-slate-400 font-mono break-all text-center select-all mt-2"
      }, defibUrl), /*#__PURE__*/React.createElement(Button, {
        onClick: function onClick() {
          return setShowJoin(false);
        },
        variant: "outline",
        className: "w-full mt-4"
      }, "Close")));
    }());
  };
  window.DefibSimScreen = DefibSimScreen;
})();